import { css } from '@/styled-system/css';

export const pageFooterContainer = css({
  marginTop: '3x',
});

// Negative margins let the Footer's dark blue background extend edge-to-edge
// while the PageFooter lives inside the padded detailMainContentPadding div
// (which SeoFooter's SrpContentWrapper fluid mode needs to break out of correctly).
export const footerBreakout = css({
  marginLeft: '-2x',
  marginRight: '-2x',
});
